import { combineReducers } from "redux";
import { ActionType } from "typesafe-actions";

import { ownedBetsActions } from "./actions";

import {
  OWNED_BETS_FAILURE,
  OWNED_BETS_REQUEST,
  OWNED_BETS_SUCCESS,
} from "../../constants/ownedBets";
import { UnlockedTipData } from "../tips/reducer";

export type Tipster = {
  id: string;
  name: string;
  avatar_url: string;
  alias: string;
  is_challenge: boolean;
  special_channel_name: string;
  special_channel_type: string;
};

export type OwnedBetsState = {
  requested: boolean;
  data: {
    open: { tips: UnlockedTipData[]; matches: any; tipsters: Tipster[] };
    closed: { tips: UnlockedTipData[]; matches: any; tipsters: Tipster[] };
  };
  isLoading: boolean;
  error: string | null;
};
export type OwnedBetsActions = ActionType<typeof ownedBetsActions>;

export const ownedBetsReducer = combineReducers<
  OwnedBetsState,
  OwnedBetsActions
>({
  requested: (state = false, action: any) => {
    switch (action.type) {
      case OWNED_BETS_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (
    state = {
      open: { tips: [], matches: [], tipsters: [] },
      closed: { tips: [], matches: [], tipsters: [] },
    },
    action: any
  ) => {
    switch (action.type) {
      case OWNED_BETS_SUCCESS:
        switch (action.payload.openstatus) {
          case "closed":
            return {
              open: state.open,
              closed: {
                tips: action.payload.data.tips,
                matches: action.payload.data.matches,
                tipsters: action.payload.data.tipsters || [],
              },
            };
          case "open":
            return {
              open: {
                tips: action.payload.data.tips,
                matches: action.payload.data.matches,
                tipsters: action.payload.data.tipsters || [],
              },
              closed: state.closed,
            };
          default:
            return {
              open: state.open,
              closed: {
                tips: [...state.closed.tips, ...action.payload.data.tips],
                matches: [
                  ...state.closed.matches,
                  ...action.payload.data.matches,
                ],
                tipsters: [
                  ...state.closed.tipsters,
                  ...(action.payload.data.tipsters || []),
                ].filter((tipster, index, self) =>
                  index === self.findIndex((t) => t.id === tipster.id)
                ),
              },
            };
        }

      default:
        return state;
    }
  },
  isLoading: (state = false, action: any) => {
    switch (action.type) {
      case OWNED_BETS_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action: any) => {
    switch (action.type) {
      case OWNED_BETS_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
